/* @flow */
/* eslint import/no-commonjs: off */

// $FlowFixMe
module.exports = require('./dist/checkout.lib');

module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// ./node_modules/paypal-checkout/index.js
// module id = qRdl
// module chunks = 1